import {Button, HStack, Stack, Text, VStack, useTheme} from '@chakra-ui/react'
import {faArrowUpRightFromSquare} from '@fortawesome/pro-regular-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import useTranslation from 'next-translate/useTranslation'
import Link from 'next/link'
import {USER_PROFILE_TABS, getProfileTabURL} from '../../constants/routes'
import UserImage from '../Molecules/UserImage'

interface Props {
  email: string
  apiKey: string
}

const UserDetails = ({email, apiKey}: Props) => {
  const theme = useTheme()
  const {t} = useTranslation('profile')

  return (
    <VStack
      w='full'
      align='stretch'
      background={theme.colors.layers.appLevel2}
      p={5}
      spacing={5}
      borderRadius={theme.radii.medium}>
      <Stack direction={['column', null, null, 'row']} spacing={5} w='full' justify='space-between'>
        <HStack justify='start' spacing={5}>
          <UserImage />
          <Text variant='mediumBold' color={theme.colors.text.basic}>
            {email}
          </Text>
        </HStack>

        <Link href={getProfileTabURL(USER_PROFILE_TABS.subscription)} passHref>
          <Button
            variant='primary'
            display='flex'
            alignSelf='center'
            w={['full', null, null, 'auto']}>
            {t('user_details_button')}
          </Button>
        </Link>
      </Stack>
      <HStack spacing='5'>
        <Text variant='mediumBold' color={theme.colors.text.basic}>
          API key: {apiKey}
        </Text>
        <Button
          as={Link}
          leftIcon={<FontAwesomeIcon icon={faArrowUpRightFromSquare} />}
          href='/api-docs'>
          API Docs
        </Button>
      </HStack>
    </VStack>
  )
}

export default UserDetails
